enum EMerchantStatus {
  TEST = 'test',
  SALES = 'sales',
  NEED_APPROVE = 'need_approve',
}

export default EMerchantStatus;
